import FamilyDialogMemberShareData from '~/components/family/dialog/DialogMemberShareData.vue';

export const useFamilyShareDataDiff = () => {
  const profile = useProfileStore();
  const dialog = useDialogStore();
  const hasData = ref<boolean>(profile.data !== null);

  const getPreviousMember = (previousMembers: FamilyMember[], memberId) => {
    return previousMembers.find((member) => member.memberId === memberId);
  };

  const findNewSharingDataMember = (
    newFamimlyMembersData: FamilyMember[],
    previousMembers: FamilyMember[]
  ) => {
    if (!hasData.value) return null;
    if (!profile.isASubscriber) return null;
    if (!profile.isParent) return null;
    const member = newFamimlyMembersData.find((member) => {
      if (member.shareResultsWithFamily) {
        const currentMember = getPreviousMember(
          previousMembers,
          member.memberId
        );
        if (currentMember && !currentMember.shareResultsWithFamily) {
          return true;
        }
      }
      return false;
    });
    return member;
  };

  watch(
    () => profile.data,
    (dataTo: Profile, dataFrom: Profile) => {
      hasData.value = dataFrom !== null;
    }
  );

  watch(
    () => profile.familyMembers,
    (to, from) => {
      const newSharingDataMember = findNewSharingDataMember(to, from);
      if (newSharingDataMember) {
        dialog.open(FamilyDialogMemberShareData, {
          member: newSharingDataMember,
        });
      }
    }
  );
};
